
import certificate2 from "../assets/certificate/10829434fb9eff32b1f0254ab6be3f80.jpg";

import certificate5 from "../assets/certificate/Screenshot (87).png";

import certificate7 from "../assets/certificate/Screenshot (86).png";

import certificate8 from "../assets/certificate/Screenshot 2023-12-26 195004.png";

import certificate9 from "../assets/certificate/Screenshot 2023-12-26 210122.png";

import certificate10 from "../assets/certificate/Screenshot 2023-12-26 211059.png";

import certificate11 from  "../assets/certificate/WhatsApp Image 2025-10-28 at 9.59.16 PM.jpeg";

// hello print c++

export const certificateData = [
  {
    id: "02",
    title: "Hotstar Clone using HTML, CSS and Bootstrap",
    image: certificate2,
    link: "https://cert.devtown.in/verify/1YBk7b",
  },

  {
    id: "05",
    title: "Python 3.5 Training",
    image: certificate5,
    link: "https://www.educba.com/certificate/?c=8BZ0KA4HU",
  },

  {
    id: "07",
    title: "Real Estate Price Prediction ",
    image: certificate7,
    link: "https://cert.devtown.in/verify/1CmA28",
  },
  {
    id: "08",
    title: "SQL (Basic) Certificate",
    image: certificate8,
    link: "https://www.hackerrank.com/certificates/89a1618056fa",
  },
  {
    id: "09",
    title: "React JS ",
    image: certificate9,
    link: "https://www.linkedin.com/posts/yash-desai-857b15209_1000-free-courses-with-free-certificates-activity-7075521073907138562-nnTE?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: "10",
    title: "HackerRank Profile",
    image: certificate10,
    link: "https://www.hackerrank.com/profile/yashdesai281",
  },
  {
    id: "11",
    title: "IT KA Khiladi",
    image: certificate11,
    link: "",
  },

  
  
];
